
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { mapState, mapGetters } from 'vuex';

export default {
name: 'productPC',
data() {
return {
defaultImg: 'this.src="' + require('../assets/product/prod/1.png') + '"',
defaultCarImg: 'this.src="' + require('../assets/product/swipe/defaultImg.png') + '"',
isOne: false,
isTwo: false,
isFour: false,
videoValue: 0,
prodValue: 0,
nowSwiperIndex:0,
settingCar: {
autoplay: true,
imgHeight: '0px',
dots: 'inside',
autoplaySpeed: 3000,
radiusDot: true,
trigger: 'click',
arrow: 'never'
},
setting: {
autoplay: false,
autoplaySpeed: 2000,
dots: 'outside',
radiusDot: true,
trigger: 'click',
arrow: 'always'
},
setting2: {
autoplay: true,
autoplaySpeed: 6000,
dots: 'outside',
radiusDot: true,
trigger: 'click',
arrow: 'never',
loop: false
},
show: false,
swiper_list: [],
categoryList: [],
IconCount: 0,
categoryDetailList: [],
categoryDetailList1: [],
categoryDetailList2: [],
message: null,
showMsg: [],
videoList: [],
videoListLength: 0,
categoryId: '',
isSLogin: '',
cacheData: null
}
},
directives: {
TransferDom
},
computed: {
...mapGetters(['thirdParty']),
},
created() {
this.login()
},
mounted() {
this.queryRotaryAdvert()
this.queryProductCategory()
this.queryProductByName()
this.queryWanderFulAdvert()
},
activated() {
if (sessionStorage.getItem('scroll') === 'ProductDetailPC') {
sessionStorage.setItem('scroll', '')
this.getCategory(sessionStorage.getItem('categoryId'))
}
},
methods: {
login() {
let query = window.location.href.split('?')[1]
this.categoryId = this.$route.params.categoryId
if (query && query.indexOf('official') > -1) {
sessionStorage.setItem('official', 'official')
this.isSLogin = 'official'
} else {
this.isSLogin = sessionStorage.getItem('official')
}

if (query && query.indexOf('categoryId') > -1) {
let prods = query.split('&')
let categoryId = prods[0].split('=')[1]
if (query.indexOf('prodId') > -1) {
let prodId = prods[1].split('=')[1]
this.getProdDetail(categoryId, prodId)
} else {
this.categoryId = categoryId
}
}
},
queryRotaryAdvert() {
let url = `${this.API_ROOT}queryRotaryAdvert`
this.$http({
method: 'get',
url: url,
params: {
status: this.isSLogin
}
}).then(
res => {
if (res.data.datas) {
res.data.datas.map(item => {
this.swiper_list.push({ img: item.picturePath, url: item.url, fallbackImg: require('../assets/product/swipe/defaultImg.png') })
})
}
},
er => {
console.log(er)
alert('轮播请求失败')
}
)
},

queryProductCategory() {
let url = `${this.API_ROOT}queryProductCategory`
this.$http({
method: 'get',
url: url,
params: {
status: this.isSLogin
}
}).then(
res => {
const resData = res.data.datas
if (resData) {
this.IconCount = resData.length % 12 == 0 ? resData.length / 12 : Math.ceil(resData.length / 12)
resData.forEach((item, index) => (item.orderId = index + 1))
for (let i = 0; i < this.IconCount; i++) {
this.categoryList.push(resData.filter(item => item.orderId <= 12 * (i + 1) && item.orderId >= 1 + 12 * i))
}
} else {
alert('产品分类数据异常')
}
},
er => {
console.log(er)
alert('请求失败')
}
)
},

queryProductByName(prodName) {
let url = `${this.API_ROOT}queryProductByName`
let data = { status: this.isSLogin }
if (prodName) {
data.prodName = prodName
}
this.$http({
method: 'get',
url: url,
params: data
}).then(
res => {
if (prodName) {
if (res.data.datas.length > 0) {
this.showMsg = res.data.datas
this.show = true
}
} else {
this.categoryDetailList = res.data.datas
let leftList = []
let leftCount = 0
let rightList = []
let rightCount = 0
res.data.datas.forEach((item, index) => {
let count = item.prodList.length > 11 ? item.prodList.length : 11
if (leftCount === 0 || leftCount <= rightCount) {
leftList.push(item)
leftCount += count
} else if ((leftCount > 0 && rightCount === 0) || rightCount < leftCount) {
rightList.push(item)
rightCount += count
}
})
this.categoryDetailList1 = leftList
this.categoryDetailList2 = rightList
if (this.categoryId && this.categoryId !== 'official') {
this.$nextTick(function() {
this.getCategory(this.categoryId)
})
}
}
},
er => {
console.log(er)
alert('请求失败')
}
)
},
queryWanderFulAdvert() {
let url = `${this.API_ROOT}queryWanderFulAdvert`
this.$http({
method: 'get',
url: url,
params: {
status: this.isSLogin
}
}).then(
res => {
if (res.data.datas.length % 2 != 0) {
let demo = { adpath: '', adpreviewPC: res.data.datas[0].adpreviewPC }
res.data.datas.push(demo)
}
this.videoList = res.data.datas
this.videoListLength = this.videoList.length / 2
},
er => {
console.log(er)
alert('请求失败')
}
)
},

videoPlay(item) {
item.playstatus = true
this.setting2.autoplay = false
},
videoPause(item) {
item.playstatus = false
let flag = true
this.videoList.forEach(obj => {
if (obj.playstatus) {
flag = false
}
})
if (flag) {
this.setting2.autoplay = true
}
},
getProdDetail(categoryId, prodId) {
let url = `${this.API_ROOT}queryProductDetailById`
this.$http({
method: 'get',
url: url,
params: {
categoryId: categoryId,
prodId: prodId
}
}).then(
res => {
if (res.data.mapDatas) {
let arr = res.data.mapDatas
arr.productList.forEach((item, index) => {
if (prodId == item.prodId && index > 0) {
res.data.mapDatas.productList.splice(index, 1)
res.data.mapDatas.productList.unshift(item)
}
})
sessionStorage.setItem('categoryId', categoryId)
sessionStorage.setItem('prodId', prodId)
this.$router.push({
path: 'ProductDetailPC',
query: { categoryId, prodId, thirdParty: this.thirdParty || 0 },
params: res.data.mapDatas })
} else {
alert('返回数据为空,请联系管理员检查')
}
},
er => {
console.log(er)
alert('请求失败')
}
)
},
gotoMoreAd() {
this.$router.push({ name: 'MoreAD' })
},
searchProdItem() {
if (this.message) {
this.queryProductByName(this.message)
} else {
this.show = false
this.showMsg = []
}
},
onSearch() {
if (this.showMsg.length > 0 && this.showMsg[0].prodName === this.message) {
this.getProdDetail(this.showMsg[0].categoryId, this.showMsg[0].prodId)
} else {
if (this.message) {
this.show = false
this.showMsg = []
alert('查无数据！')
} else {
alert('请输入要查询的数据！')
}
}
},
getCategory(code) {
if (code) {
document.getElementById(code).scrollIntoView()
}
},
showImgDetail(e) {
if(e.srcElement.tagName == 'IMG'){
let item = this.swiper_list[this.nowSwiperIndex]
if (item.url) {
let Category = item.url.split('@')
this.getProdDetail(Category[0], Category[1])
}
}
}
},

beforeRouteEnter(to, from, next) {
to.meta.keepAlive = true
next()
},
beforeRouteLeave(to, from, next) {
if (to.name == 'ProductDetailPC' || to.name == 'PictureShow' || to.name == 'MoreAD') {
sessionStorage.setItem('scroll', to.name)
from.meta.keepAlive = true
to.meta.keepAlive = false
}
next()
}
}



// WEBPACK FOOTER //
// ./src/components/ProductPC.vue